import { MapPin, User, Clock, UserCheck } from "lucide-react";
import { timeAgo, formatDakar } from "@/lib/time";

const AlertCard = ({ alert, selected, onClick, isNew }) => {
  const assigned = !!alert.assigned_to;
  return (
    <button
      data-testid={`alert-card-${alert.alert_id}`}
      onClick={onClick}
      className={`w-full text-left rounded-xl p-4 relative overflow-hidden transition-all duration-200 border-2 ${
        selected
          ? "border-yellow-500/70 bg-slate-800/80 shadow-[0_0_15px_rgba(234,179,8,0.2)]"
          : assigned
          ? "border-amber-500/30 bg-slate-900/80 hover:border-amber-500/50"
          : "border-red-500/40 bg-red-950/30 hover:border-red-500/70"
      } ${isNew ? "animate-flash !border-red-400" : ""}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${assigned ? "bg-amber-400" : "bg-red-500 animate-pulse"}`} />
          <span className="font-display font-semibold text-slate-100 truncate flex items-center gap-1.5">
            <User className="w-3.5 h-3.5 text-slate-400 shrink-0" />
            {alert.user_name}
          </span>
        </div>
        <span className={`font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full shrink-0 ${
          assigned ? "bg-amber-500/10 text-amber-400 border border-amber-500/30" : "bg-red-500/10 text-red-400 border border-red-500/30"
        }`}>
          {assigned ? "En cours" : "Active"}
        </span>
      </div>

      <div className="mt-3 space-y-1.5 text-xs text-slate-400 font-mono">
        <div className="flex items-center gap-1.5">
          <MapPin className="w-3.5 h-3.5 text-emerald-500" />
          {alert.current_location
            ? `${alert.current_location.lat.toFixed(4)}, ${alert.current_location.lng.toFixed(4)}`
            : "Position inconnue"}
        </div>
        <div
          className="flex items-center gap-1.5 cursor-help"
          title={`Déclenchée le ${formatDakar(alert.triggered_at)} (heure de Dakar)`}
          data-testid={`alert-time-${alert.alert_id}`}
        >
          <Clock className="w-3.5 h-3.5 text-slate-500" />
          {timeAgo(alert.triggered_at)}
        </div>
        {assigned && (
          <div className="flex items-center gap-1.5 text-amber-400">
            <UserCheck className="w-3.5 h-3.5" />
            {alert.assigned_to}
          </div>
        )}
      </div>
    </button>
  );
};

const AlertList = ({ alerts, selectedId, onSelect, newIds }) => {
  if (alerts.length === 0)
    return (
      <div className="flex flex-col items-center justify-center h-full text-center px-6 py-16 text-slate-500">
        <div className="w-14 h-14 rounded-full bg-emerald-950 border border-emerald-500/30 flex items-center justify-center mb-4">
          <MapPin className="w-6 h-6 text-emerald-500" />
        </div>
        <p className="font-display font-semibold text-slate-300">Aucune alerte active</p>
        <p className="text-xs mt-1">Le territoire est calme. Les nouvelles alertes apparaîtront ici.</p>
      </div>
    );

  return (
    <div className="space-y-3 p-4" data-testid="alert-list">
      {alerts.map((a) => (
        <AlertCard
          key={a.alert_id}
          alert={a}
          selected={selectedId === a.alert_id}
          isNew={newIds?.has(a.alert_id)}
          onClick={() => onSelect(a)}
        />
      ))}
    </div>
  );
};

export { timeAgo };
export default AlertList;
